import { useCallback, useEffect, useState } from 'react';

import { WalletOperationSearch, WalletOperationsPage, fetchWalletOperations } from 'lib/models/walletOperations';

const emptyPage: WalletOperationsPage = { elements: [], total: 0, totalRelation: 'eq', failed: false };

/**
 * One page of the wallet operations the session may read.
 *
 * The narrowing and the window are the endpoint's own, so they are handed to it rather than
 * applied to the answer: the hook re-reads whenever the search it was given changes, which
 * is how a filter or a page change becomes a request.
 *
 * @param search What to narrow to, and which page is wanted
 */
function useWalletOperations(search: WalletOperationSearch) {
	const [loading, setLoading] = useState<boolean>(true);
	const [page, setPage] = useState<WalletOperationsPage>(emptyPage);

	const refetch = useCallback(async () => {
		setLoading(true);
		const response = await fetchWalletOperations(search);
		setPage(response);
		setLoading(false);
	}, [search]);

	useEffect(() => {
		refetch();
	}, [refetch]);

	return {
		loading,
		operations: page.elements,
		total: page.total,
		totalRelation: page.totalRelation,
		failed: page.failed,
		refetch,
	};
}

export default useWalletOperations;
